export default __webpack_public_path__ + "assets/png/602e4c8e9447707df1957046c3e120fe.png";